import { Button, Typography } from '@braskai/ui-kit';

import { Box, CardMedia, Stack, StackProps } from '@mui/material';

import Image from '@/shared/assets/images/error-page.png';
import { useInterfaceLanguage } from '@/shared/i18n';

export const SomethingWrongError = (props: StackProps) => {
  const { t } = useInterfaceLanguage();
  const handleRefreshPageClick = () => window.location.reload();

  return (
    <Stack alignItems="center" gap={20} justifyContent="center" maxWidth={300} minWidth="100%" {...props}>
      <CardMedia
        sx={{
          height: 133,
          width: 230,
        }}
        alt=""
        component="img"
        src={Image}
      />
      <Stack gap={4} textAlign="center">
        <Typography color="grey.900" variant="title-3-md">
          {t('editor.error.generic')}
        </Typography>
        <Typography color="grey.500" variant="body-1">
          {t('editor.error.workingOnIt')}
          <br />
          {t('editor.error.tryRefresh')}
        </Typography>
      </Stack>
      <Box>
        <Button data-testid="something-wrong-error-refresh-page" size="lg" onClick={handleRefreshPageClick}>
          {t('editor.error.refresh')}
        </Button>
      </Box>
    </Stack>
  );
};
